/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  styled,
  TextField,
  Button,
  Paper,
  Grid,
  Divider,
  Box,
  Typography,
  InputAdornment,
  IconButton
} from '@mui/material';
import * as yup from 'yup';
import Iconify from '../../iconify';
import Modal from '../../modal/Modal';
import { ItemCodeSearchForm, ItemNameSearchForm, LineVendorSearchForm } from '../../search';
import { useAuthSap, useRules } from '../../../hooks';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

// Lista de artículos que requieren obligatoriamente el molde
const REQUIRED_MOLD_ITEMS = [
  'CT039', 'CT040', 'CT041', 'CT042', 'CT043', 
  'CT044', 'CT045', 'CT046', 'CT050', 'CT047', 
  'CT048', 'CT049', 'CT090', 'CT093'
];

// Expresión regular: 1 letra (mayúscula/minúscula) seguida de exactamente 4 números
const MOLD_REGEX = /^[A-Za-z]\d{4}$/;

export default function PRDocumentLineForm(props) {
  const { business, docLine, addDoc, msgError } = props;
  const { inRules } = useRules();
  const { collectionWH, collectionCF, collectionCC, TaxesQuery, Warehouses, CashFlow, CenterCost } = useAuthSap();
  const [taxes, setTaxes] = useState([]);
  const [rules, setRules] = useState([]);
  const [loadWarehouses, setLoadWarehouses] = useState(true);
  const [loadCashFlow, setLoadCashFlow] = useState(true);
  const [loadCenterCost, setLoadCenterCost] = useState(true);
  
  const [formData, setFormData] = useState({
    ItemCode: docLine != null ? docLine?.ItemCode : '',
    ItemDescription: docLine != null ? docLine?.ItemDescription : '',
    LineVendor: docLine != null ? docLine?.LineVendor : '',
    nameVendor: docLine != null ? docLine?.nameVendor : '',
    U_Comentarios: docLine != null ? docLine?.U_Comentarios : '',
    U_Molde: docLine != null ? docLine?.U_Molde : '', // <-- Nuevo campo añadido
    MeasureUnit: docLine != null ? docLine?.MeasureUnit : '',
    UoMCode: docLine != null ? docLine?.UoMCode : '',
    WarehouseCode: docLine != null ? docLine?.WarehouseCode : 0,
    Quantity: docLine != null ? docLine?.Quantity : 0,
    UnitPrice: docLine != null ? docLine?.UnitPrice : 0,
    CostingCode: docLine != null ? docLine?.CostingCode : 0,
    Currency: docLine != null ? docLine?.Currency : 'MXP',
    TaxCode: docLine != null ? docLine?.TaxCode : 0
  });
  
  const [typeModal, setTypeModal] = useState('ItemCode');
  const [titleModal, setTitleModal] = useState('código de artículo');
  const [open, setOpen] = useState(!docLine);
  const [errors, setErrors] = useState([]);

  const [isMsgRules, setIMsgRule ] = useState();
  const [isValidRules, setIsValidRule ] = useState();

  const PurchaseLineSchema = yup.object().shape({
    ItemCode: yup
      .string()
      .min(1, 'Mínimo 1 carácteres')
      .required('No.Articulo es requerido'),
    ItemDescription: yup
      .string()
      .min(1, 'Mínimo 1 carácteres')
      .required('Descripción es requerido'),
    LineVendor: yup
      .string()
      .min(1, 'Mínimo 1 carácteres')
      .required('No.Proveedor es requerido'),
    MeasureUnit: yup
      .string()
      .min(1, 'Mínimo 1 carácteres')
      .required('Unidad de medida es requerido'),
    WarehouseCode: yup
      .string()
      .oneOf(collectionWH.map(item => item.WarehouseCode), 'Selecciona un almacen')
      .required('El almacen es requerido'),
    CostingCode: yup
      .string()
      .oneOf(collectionCC.map(item => item.center_cost.code), 'Selecciona un centro de costo')
      .required('El centro de costo es requerido'),
    TaxCode: yup
      .string()
      .oneOf(taxes.map(item => item.Code), 'Selecciona un impuesto')
      .required('El impuesto es requerido'),
    Quantity: yup
      .number()
      .min(1, 'Cantidad debe de ser mayor a 0'),
    UnitPrice: yup
      .number()
      .min(0.01, 'Precio unidad debe de ser mayor a 0'),
    
    // Validación Condicional para U_Molde basándose en ItemCode
    U_Molde: yup.string().when('ItemCode', {
      is: (val) => REQUIRED_MOLD_ITEMS.includes(val),
      then: () => yup.string()
        .required('El molde es obligatorio para este artículo')
        .length(5, 'El molde debe tener exactamente 5 caracteres')
        .matches(MOLD_REGEX, 'Formato inválido. Debe ser una letra seguida de 4 números (Ej: A0123)'),
      otherwise: () => yup.string().notRequired()
    })
  }, [['ItemCode', 'U_Molde']]); // Se añade la dependencia circular en el arreglo de Yup

  const fetchData = async () => {
    try {
      await CashFlow();
      setLoadCashFlow(false);
      await Warehouses();
      setLoadWarehouses(false);
      await CenterCost();
      setLoadCenterCost(false);
      const { result } = await TaxesQuery();
      setTaxes(result);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRules = async () => {
    try {
      const { result } = await inRules();
      setRules(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    localStorage.setItem('business', business);
    fetchData();
    fetchRules();
  }, []);

  const handleOpenModal = (type) => {
    if (type === 'ItemCode') {
      setTitleModal('código de artículo');
    } else if (type === 'ItemDescription') {
      setTitleModal('descripción de artículo');
    } else if(type === 'LineVendor') {
      setTitleModal('nombre de proveedor');
    }
    setTypeModal(type);
    setOpen(true);
  };
  
  const handleCloseModal = () => {
    setOpen(false);
  };
  
  const handleSearch = (search) => {
    if(typeModal === 'LineVendor') {
      setFormData((prevState) => ({ ...prevState, LineVendor: search.CardCode, nameVendor: search.CardName }));
      setErrors({ ...errors, LineVendor: "" });
    } else {
      const newItemCode = search.ItemCode != null ? search.ItemCode : '';
      setFormData((prevState) => ({ 
        ...prevState, 
        ItemCode: newItemCode,
        ItemDescription: search.ItemName != null ? search.ItemName : '',
        MeasureUnit: search.PurchaseUnit != null ? search.PurchaseUnit : '',
        UoMCode: search.PurchaseUnit != null ? search.PurchaseUnit : '',
        WarehouseCode: search.DefaultWarehouse != null ? search.DefaultWarehouse : 0,
      }));
      setErrors({ ...errors, 
        ItemCode: "", 
        ItemDescription: "",
        MeasureUnit: "",
        WarehouseCode: "",
      });
    };
    setOpen(false);
  };

  const inputChange = async (event) => {
    const { name, value } = event.target;
    let processedValue = value;

    if (name === 'MeasureUnit') {
      processedValue = value.toUpperCase();
      setFormData((prevState) => ({ ...prevState, 'UoMCode': processedValue }));
    } else if (name === 'U_Molde') {
      processedValue = value.toUpperCase(); // Forzar mayúscula en la letra del molde
    }

    setFormData((prevState) => ({ ...prevState, [name]: processedValue }));
    await validateField(name, processedValue);
  };

  const validateField = async (name, value) => {
    try {
      // Pasamos el contexto completo del formulario a validateAt para que la condicional de Yup funcione en tiempo real
      await PurchaseLineSchema.validateAt(name, { ...formData, [name]: value });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: err.errors[0] }));
      }
    }
  };

  const validRules = async (itemCode, centerCost) => {
    try {
      const endsIn = centerCost.slice(-1);
      const goWith = itemCode.slice(0, 2);
      
      let isCC;
      if (rules.some(x => x.ends_in === endsIn && x.status === true)) {
        isCC = rules.find(x => x.ends_in === endsIn);
      };

      let isItem;
      if (rules.some(x => x.go_with === goWith && x.status === true)) {
        isItem = rules.find(x => x.go_with === goWith);
      };
      
      if (isCC && isItem) {
        if (isCC.go_with !== goWith) {
          setIMsgRule(`No es permitido utilizar ${centerCost} con ${itemCode}`);
          return false;
        }
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const onAdd = async () => {
    try {
      await PurchaseLineSchema.validate(formData, { abortEarly: false });
      const valid = await validRules(formData.ItemCode, formData.CostingCode);
      if (!valid) return;
      setIMsgRule(null);
      addDoc(formData);
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        setErrors(err.inner.reduce((acc, curr) => {
          acc[curr.path] = curr.message;
          return acc;
        }, {}));
      }
    }
  };

  return (
    <>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={3}>
            <Item>
              <TextField 
                disabled 
                id="ItemCode"
                name="ItemCode"
                label="No.Articulo" 
                type="text" 
                size="small" 
                variant="outlined" 
                fullWidth 
                value={formData.ItemCode}
                error={Boolean(errors.ItemCode)}
                helperText={errors.ItemCode}
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <IconButton onClick={() => handleOpenModal('ItemCode')} edge="start">
                      <Iconify icon="ic:outline-settings" />
                    </IconButton>
                  </InputAdornment>
                }}
              />
            </Item>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Item>
              <TextField 
                disabled 
                id="ItemDescription"
                name="ItemDescription"
                label="Descripción" 
                type="text" 
                size="small" 
                variant="outlined" 
                fullWidth 
                value={formData.ItemDescription}
                error={Boolean(errors.ItemDescription)}
                helperText={errors.ItemDescription}
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <IconButton onClick={() => handleOpenModal('ItemDescription')} edge="start">
                      <Iconify icon="ic:outline-settings"/>
                    </IconButton>
                  </InputAdornment>
                }}
              />
            </Item>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Item>
              <TextField 
                disabled 
                id="LineVendor"
                name="LineVendor"
                label="Proveedor" 
                type="text" 
                size="small" 
                variant="outlined" 
                fullWidth 
                onChange={inputChange}
                value={formData.LineVendor}
                error={Boolean(errors.LineVendor)}
                helperText={errors.LineVendor}
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <IconButton onClick={() => handleOpenModal('LineVendor')} edge="start">
                      <Iconify icon="ic:outline-settings" />
                    </IconButton>
                  </InputAdornment>
                }}
              />
            </Item>
          </Grid>
          
          {/* NUEVO CAMPO: U_Molde en la interfaz */}
          <Grid item xs={12} sm={12} md={4}>
            <Item>
              <TextField 
                id="U_Molde"
                name="U_Molde"
                label="Molde" 
                type="text" 
                size="small" 
                variant="outlined" 
                fullWidth 
                onChange={inputChange}
                value={formData.U_Molde}
                error={Boolean(errors.U_Molde)}
                helperText={errors.U_Molde}
                inputProps={{ maxLength: 5 }} // Restringe visualmente a un máximo de 5 caracteres
                placeholder="Ej: A0123"
              />
            </Item>
          </Grid>

          <Grid item xs={12} sm={12} md={8}>
            <Item>
              <TextField 
                autoFocus 
                id="U_Comentarios"
                name="U_Comentarios"
                label="Comentario" 
                type="text" 
                size="small" 
                variant="outlined" 
                fullWidth 
                onChange={inputChange}
                value={formData.U_Comentarios}
                multiline
                rows={1}
                autoComplete="off"
              />
            </Item>
          </Grid>
          <Divider sx={{ my: 2 }} />
        </Grid>
        <Divider sx={{ my: 2, borderBottom: '1px dashed #EBEDF3' }}/>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={6}>
            <Item>
              <TextField 
                id="MeasureUnit"
                name="MeasureUnit"
                label="Unidad Medida" 
                type="text" 
                size="small" 
                variant="outlined" 
                fullWidth 
                onChange={inputChange}
                value={formData.MeasureUnit}
                error={Boolean(errors.MeasureUnit)}
                helperText={errors.MeasureUnit}
                autoComplete="off"
              />
            </Item>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Item>
              <TextField 
                select 
                SelectProps={{ native: true }} 
                id="WarehouseCode"
                name="WarehouseCode"
                label="Almacen"
                onChange={inputChange}
                value={formData.WarehouseCode} 
                error={Boolean(errors.WarehouseCode)}
                helperText={errors.WarehouseCode}
                fullWidth 
                size="small">
                <option value={0}>Selecciona un almacen</option>
                {collectionWH.map((option) => (
                  <option key={option.WarehouseCode} value={option.WarehouseCode}>{option.WarehouseCode} - {option.WarehouseName}</option>
                ))}
              </TextField>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Item>
              <TextField 
                type="number"
                onFocus={(e) => e.target.select()} 
                id="Quantity"
                name="Quantity"
                label="Cantidad" 
                size="small" 
                variant="outlined" 
                fullWidth 
                onChange={inputChange}
                value={formData.Quantity}
                error={Boolean(errors.Quantity)}
                helperText={errors.Quantity}
                autoComplete="off"
              />
            </Item>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Item>
              <TextField 
                type="number"
                onFocus={(e) => e.target.select()}
                id="UnitPrice"
                name="UnitPrice"
                label="Precio" 
                size="small" 
                variant="outlined" 
                fullWidth 
                onChange={inputChange}
                value={formData.UnitPrice}
                error={Boolean(errors.UnitPrice)}
                helperText={errors.UnitPrice}
                autoComplete="off"
              />
            </Item>
          </Grid>
          {taxes && (
            <Grid item xs={12} sm={6} md={6}>
              <Item>
                <TextField
                  disabled={loadCenterCost}
                  select 
                  SelectProps={{ native: true }} 
                  id="TaxCode"
                  name="TaxCode"
                  label="Impuestos"
                  onChange={inputChange}
                  value={formData.TaxCode} 
                  error={Boolean(errors.TaxCode)}
                  helperText={errors.TaxCode}
                  fullWidth 
                  size="small">
                  <option value={0}>Selecciona un impuesto</option>
                  {taxes.map((option, index) => (
                    <option key={index} value={option.Code}>{option.Code} - {option.Name}</option>
                  ))}
                </TextField>
              </Item>
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={6}>
            <Item>
              <TextField
                disabled={loadCenterCost}
                select 
                SelectProps={{ native: true }} 
                id="CostingCode"
                name="CostingCode"
                label="Centro de Costo"
                onChange={inputChange}
                value={formData.CostingCode} 
                error={Boolean(errors.CostingCode)}
                helperText={errors.CostingCode}
                fullWidth 
                size="small">
                <option value={0}>Selecciona un centro de costo</option>
                {collectionCC.map((option) => (
                  <option key={option.id} value={option.center_cost.code}>{option.center_cost.code} - {option.center_cost.description}</option>
                ))}
              </TextField>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Item>
              <TextField
                select 
                SelectProps={{ native: true }} 
                id="Currency"
                name="Currency"
                label="Tipo Moneda"
                onChange={inputChange}
                value={formData.Currency} 
                error={Boolean(errors.Currency)}
                helperText={errors.Currency}
                fullWidth 
                size="small">
                <option key={0} value={' '}>Selecciona la moneda</option>
                <option key={1} value={'MXP'}>MXP</option>
                <option key={2} value={'USD'}>USD</option>
                <option key={3} value={'EUR'}>EUR</option>
                <option key={4} value={'GBP'}>LIBRA</option>
              </TextField>
            </Item>
          </Grid>
        </Grid>
        <Divider sx={{ my: 2, borderBottom: '1px dashed #EBEDF3' }}/>
        <Box sx={{ alignItems: 'center', display: 'flex'}}>
          {msgError != null ? (
            <Typography color="error.main" variant="body2">
              {msgError}
            </Typography>
          ):null}
          {isMsgRules != null ? (
            <Typography color="error.main" variant="body2">
              {isMsgRules}
            </Typography>
          ):null}
          <Box sx={{ flexGrow: 1 }} />
          <Button variant="contained" onClick={onAdd} startIcon={<Iconify icon={docLine == null ? 'eva:plus-fill':'radix-icons:update'} />}>
            {docLine == null ? 'Agregar':'Actualizar'}
          </Button> 
        </Box>  
      </Box>
      <Modal title={`Búsqueda por ${titleModal}`} maxWidth={'xs'} open={open} onClose={handleCloseModal}>
        {typeModal === 'ItemCode' && <ItemCodeSearchForm send={handleSearch}/>}
        {typeModal === 'ItemDescription' && <ItemNameSearchForm send={handleSearch}/>}
        {typeModal === 'LineVendor' && <LineVendorSearchForm send={handleSearch}/>}
      </Modal>
    </>
  )
}